import { render, staticRenderFns } from "./BenefitContainer.vue?vue&type=template&id=62315e9f&"
import script from "./BenefitContainer.vue?vue&type=script&lang=js&"
export * from "./BenefitContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports